/* David Pladen — customer videos in the review photo window (.okx of
 * sections/dp-product-reviews, opened by assets/dp-product.js).
 * snippets/dp-head.liquid lists which review photos are the cover of a video
 * (#dp-review-videos: photo file name -> mp4). When such a photo is shown in
 * the window it is swapped for the video with controls; it stops when the
 * window closes or moves on.
 */

(() => {
  let map = {};
  try {
    map = JSON.parse(document.getElementById('dp-review-videos')?.textContent || '{}');
  } catch (e) {
    return;
  }
  if (!Object.keys(map).length) return;

  const fileName = (src) => (src || '').split('?')[0].split('/').pop();
  const coverName = (name) => name.replace(/_\d+x\d*(?=\.)/, '');

  const swap = (pane) => {
    const img = pane.querySelector(':scope > img');
    if (!img) return;
    const mp4 = map[coverName(fileName(img.currentSrc || img.src))];
    if (!mp4) return;
    const video = document.createElement('video');
    video.src = mp4;
    video.poster = img.src;
    video.controls = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.setAttribute('aria-label', img.alt || '');
    video.className = img.className;
    video.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;background:#000';
    pane.replaceChildren(video);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.muted = true;
      const play = video.play();
      if (play && play.catch) play.catch(() => {});
    }
  };

  const watch = (box) => {
    if (box.dataset.dpVideoBound) return;
    box.dataset.dpVideoBound = 'true';
    const pane = box.querySelector('[data-okx-img]');
    if (!pane) return;
    new MutationObserver(() => swap(pane)).observe(pane, { childList: true });
    // stop playing when the window closes
    new MutationObserver(() => {
      if (box.hidden) box.querySelectorAll('video').forEach((v) => v.pause());
    }).observe(box, { attributes: true, attributeFilter: ['hidden'] });
  };

  // Round dark play button on the photo tiles that open a video
  const markTiles = () => {
    if (!document.getElementById('dp-review-video-css')) {
      const css = document.createElement('style');
      css.id = 'dp-review-video-css';
      css.textContent =
        '.dp-has-video{position:relative}' +
        '.dp-play{position:absolute;top:50%;left:50%;z-index:1;width:40px;height:40px;margin:-20px 0 0 -20px;' +
        'border-radius:50%;background:rgba(0,0,0,.85);display:grid;place-items:center;pointer-events:none}' +
        '.dp-play svg{width:14px;height:14px;margin-left:3px;fill:#fff}';
      document.head.appendChild(css);
    }
    document.querySelectorAll('[data-dp-reviews] [data-okm]').forEach((tile) => {
      const img = tile.querySelector('img');
      if (!img || tile.querySelector('.dp-play')) return;
      if (!map[coverName(fileName(img.getAttribute('src')))]) return;
      tile.classList.add('dp-has-video');
      const play = document.createElement('span');
      play.className = 'dp-play';
      play.setAttribute('aria-hidden', 'true');
      play.innerHTML = '<svg viewBox="0 0 14 16" focusable="false"><path d="M0 0l14 8-14 8z"/></svg>';
      tile.appendChild(play);
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-okx]').forEach(watch);
    markTiles();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
